<template>
  <span>
    <img
      :src="statusImage"
      :alt="rowData.direction"
      :title="rowData.direction"
    />
  </span>
</template>

<script>
export default {
  name: 'CallDirection',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusImage() {
      switch (this.rowData.direction) {
        case 'out_going':
          return require('@/assets/images/icon-outgoing.svg')
        case 'income':
          return require('@/assets/images/icon-incoming.svg')
        case 'local':
          return require('@/assets/images/icon-local.svg')
        case 'cross_tenants':
          return require('@/assets/images/icon-outgoing.svg')
        default:
          return require('@/assets/images/icon-outgoing.svg')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  max-width: 20px;
  height: auto;
}
</style>
